Ext.define('SA.model.map.Export', {
    extend: 'Ext.data.Model',
    mixins: ['SA.model.ObservableChangeMixin'],

    dpi: 300,

    fields: [
        {name: 'extent', convert: SA.modelConvert('SA.model.map.Extent')},

        {name: 'pointsToken'},

        {name: 'units', defaultValue: 'inches'},

        {name: 'width', defaultValue: 11 * 300},
        {name: 'height', defaultValue: 8.5 * 300},

        {name: 'insetMap', convert: SA.modelConvert('SA.model.map.ExportOverlay')},
        {name: 'legend', convert: SA.modelConvert('SA.model.map.LegendOverlay')},
        {name: 'map', convert: SA.modelConvert('SA.model.map.ExportOverlay')},
        {name: 'northArrow', convert: SA.modelConvert('SA.model.map.ExportOverlay')},
        {name: 'scaleBar', convert: SA.modelConvert('SA.model.map.ExportOverlay')},

        {name: 'labels', convert: SA.modelArrayConvert('SA.model.map.ExportTextOverlay')}
    ],

    addTextLabel(label) {
        this.setWithEvent('labels', this.getTextLabels().concat(label));
    },

    getConversionFactor() {
        return this.getUnits() === 'inches' ? this.dpi : 1;
    },

    getDisplaySize(field) {
        return this.get(field) / this.getConversionFactor();
    },

    getExtent() {
        return this.get('extent');
    },

    getHeight() {
        return this.get('height');
    },

    getInsetMap() {
        return this.get('insetMap');
    },

    getLegend() {
        return this.get('legend');
    },

    getMap() {
        return this.get('map');
    },

    getNorthArrow() {
        return this.get('northArrow');
    },

    getPointsToken() {
        return this.get('pointsToken');
    },

    getScaleBar() {
        return this.get('scaleBar');
    },

    getTextLabels() {
        return this.get('labels');
    },

    getUnits() {
        return this.get('units');
    },

    getWidth() {
        return this.get('width');
    },

    removeTextLabel(label) {
        var oldLabels = this.getTextLabels(),
            labels = [];

        oldLabels.forEach(oldLabel => {
            if (oldLabel !== label) {
                labels.push(oldLabel);
            }
        });

        this.setWithEvent('labels', labels);
    },

    setDisplaySize(field, value) {
        this.setSize(field, Math.round(value * this.getConversionFactor()));
    },

    setOrientation(orientation) {
        var height = this.getHeight(),
            width = this.getWidth();

        if ((orientation === 'landscape') === (height > width)) {
            this.setSize({
                height: width,
                width: height
            });
        }
    },

    setSize(values, value) {
        var obj = values;

        if (Ext.isString(values)) {
            obj = SA.createObject(values, value);
        }

        this.set(obj);

        if (this.getWidth() < 30) {
            this.set('width', 30);
        }

        if (this.getHeight() < 30) {
            this.set('height', 30);
        }

        for (let prop in obj) {
            this.fireEvent('set:' + prop, this);
        }
    },

    setUnits(units) {
        this.setWithEvent('units', units);
    }
});
